/**
 * Sicherheitsprüfung (Inhaber 02.11.2026): Dateien aus dem Speicher nur als PDF oder Bild in einem Tab öffnen.
 *
 * Eine Blob-Adresse (blob:https://app…) gehört zum Ursprung der App. Öffnet der Browser sie als Seite, läuft ihr Inhalt wie eine
 * Seite der App: Eine Datei, die mit der Art application/xml (XHTML mit Skript) hochgeladen wurde, brachte so fremdes HTML in
 * die App (der Bucket documents erlaubt application/xml für E-Rechnungen, die Dateiart setzt die hochladende Person). Die
 * Inhaltsrichtlinie (CSP) bremst Skripte, ist aber nicht die einzige Sicherung. Deshalb: Geöffnet wird nur, was der Browser
 * nie als Seite ausführt (PDF, PNG, JPEG, WebP, GIF), mit genau dieser Art; alles andere wird als Download angeboten.
 */
export const OEFFENBARE_ARTEN = ["application/pdf", "image/png", "image/jpeg", "image/webp", "image/gif"] as const;

const art = (t: string | null | undefined) => (t ?? "").split(";")[0]!.trim().toLowerCase();

/** Darf eine Datei dieser Art in einem Tab geöffnet werden? */
export function oeffenbar(mime: string | null | undefined): boolean {
  return (OEFFENBARE_ARTEN as readonly string[]).includes(art(mime));
}

/**
 * Blob zum Anzeigen: mit der erwarteten Art (aus der Datenbank) bzw. der Art der Datei, wenn sie öffenbar ist; sonst als
 * application/octet-stream (lädt herunter statt anzuzeigen). `oeffnen` sagt, ob ein Tab sinnvoll ist.
 */
export function sichererBlob(blob: Blob, erwartet?: string | null): { blob: Blob; oeffnen: boolean } {
  const typ = [art(erwartet), art(blob.type)].find((t) => t && oeffenbar(t));
  if (typ) return { blob: blob.type === typ ? blob : new Blob([blob], { type: typ }), oeffnen: true };
  return { blob: new Blob([blob], { type: "application/octet-stream" }), oeffnen: false };
}
